import React, { createContext, useContext, useState, useCallback } from 'react';

interface AppLoadingContextValue {
  isAppLoading: boolean;
  setAppLoading: (loading: boolean) => void;
}

const AppLoadingContext = createContext<AppLoadingContextValue>({
  isAppLoading: true,
  setAppLoading: () => {},
});

export const useAppLoading = () => useContext(AppLoadingContext);

export const AppLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAppLoading, setIsAppLoading] = useState(true);

  const setAppLoading = useCallback((loading: boolean) => {
    setIsAppLoading(loading);
  }, []);

  return (
    <AppLoadingContext.Provider value={{ isAppLoading, setAppLoading }}>
      {children}
    </AppLoadingContext.Provider>
  );
};